import { httpPost } from "src/utils/http/http";

export function web3Login(
  address: string,
  signature: string,
  csrf?: string
): Promise<unknown> {
  const headers = new Headers();
  headers.append("Cookie", `csrf=${csrf}`);
  headers.append("Content-Type", "application/json");
  return httpPost(
    "api/auth/web3_login",
    { userAddress: address, signature, csrf },
    { headers, redirect: "follow" }
  );
}
